import type { Router } from 'vue-router'
import NProgress from 'nprogress'
import { useUserStore } from '@/stores/user'
import { ElMessage } from 'element-plus'

// 白名单路由
const whiteList = ['/login', '/404', '/403']

export function setupRouterGuards(router: Router) {
  // 前置守卫
  router.beforeEach(async (to, from, next) => {
    NProgress.start()

    const userStore = useUserStore()
    const token = userStore.token

    // 白名单直接放行
    if (whiteList.includes(to.path)) {
      next()
      return
    }

    // 没有 Token，跳转到登录页
    if (!token) {
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
      return
    }

    // 有 Token，集中检查路由权限。缺少角色/权限数据时由 store 内 fallback 兼容联调登录。
    if (!userStore.canAccessRoute(to)) {
      ElMessage.error('没有权限访问该页面')
      next('/403')
      return
    }

    next()
  })

  // 后置守卫
  router.afterEach((to) => {
    NProgress.done()
    // 设置页面标题
    document.title = to.meta.title ? `${to.meta.title} - 茶叶期货管理系统` : '茶叶期货管理系统'
  })

  // 错误处理
  router.onError((error) => {
    NProgress.done()
    console.error('路由错误:', error)
    ElMessage.error('页面加载失败')
  })
}
